import { Grid2 } from "@mui/material";
import styles from "./DomainDetails.module.scss";
import CustomInput from "../../../../../../../../GlobalComponents/CustomInput/CustomInput";
import { DomainInfo } from "../DomainInfo/DomainInfo";
import { domainText } from "../ConstantData/DomainConstantData";
import { useEffect } from "react";

export function DomainDetails(props) {
  const {
    domainName,
    siteData,
    checkAndSetDomainValue,
    errorMessage,
    setErrorMessage,
    setDomainName,
  } = props;

  useEffect(() => {
    setDomainName("");
  }, []);

  const handleDomainNameChange = (value) => {
    const isDuplicate = siteData?.domain?.some(
      (domainItem) => domainItem.name === value,
    );
    if (isDuplicate) {
      setErrorMessage("Domain name already exists.");
    } else {
      setErrorMessage("");
    }
    checkAndSetDomainValue(value);
  };

  return (
    <Grid2 className={styles.DomainDetailsContainer}>
      <Grid2 className={styles.checkinputflex}>
        <Grid2 className={styles.inputWidth}>
          <CustomInput
            title="Domain URL"
            placeholder="Enter Your Domain URL"
            value={domainName}
            setValue={(e) => handleDomainNameChange(e.replace(/\s/g, ""))}
            error={!!errorMessage}
            errorMessage={errorMessage}
          />
        </Grid2>
      </Grid2>
      <DomainInfo domainText={domainText} />
    </Grid2>
  );
}
